<template>
  <transition 
    enter-active-class="opacity-0"
    enter-to-class="opacity-100"
    leave-to-class="opacity-0"
    @enter="resetTimeout"
  >
    <div @click="closeModal" v-if="isOpen" class="transition ease-in-out duration-300 fixed z-20 inset-0 lg:bg-black/[0.70] modal-background modal-close" style="margin-left: 0 !important;">
      <div class="w-full lg:w-[774px] flex lg:items-center justify-center lg:h-screen lg:mx-auto h-screen z-40">
        <div class="flex flex-col lg:flex-row w-full relative">
        <div 
          @click="closeModal" 
          class="modal-close cursor-pointer z-50 absolute top-2 right-4 bg-transparent md:-top-2 md:-right-4 md:bg-pink rounded-full flex items-center justify-center text-2xl block p-2"
        >
          <svg @click="closeModal" class="modal-close fill-current text-white block" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path @click="closeModal" class="modal-close" d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
        </div>
        <div class="w-full lg:w-1/2">
          <div class="font-['Bebas_Neue'] bg-gradient-to-b from-purple to-pink h-[20vh] lg:h-[540px] md:rounded-tl-3xl md:rounded-bl-3xl">
            <div class="bg-black bg-opacity-50 h-full flex items-center justify-center md:rounded-tl-3xl md:rounded-bl-3xl">
              <h1 class="font-['Bebas_Neue'] text-white text-4xl px-3 lg:px-0 lg:text-6xl text-center">We Work For A World Where Breast Cancer Isn't Terminal</h1>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 flex flex-col justify-start items-start relative lg:overflow-hidden bg-white h-full md:h-auto md:rounded-br-3xl md:rounded-tr-3xl">
          <div 
            id="progressBar" 
            class="transition-all ease-in-out duration-300 bg-green-500 h-2 absolute top-0"
            v-bind:class="progressClassObject"
          ></div>
              
              <transition
                enter-from-class="-translate-x-full"
                enter-to-class="translate-x-0"
                :leave-to-class="this.donationWidgetState.leaveToDirection"
              >
                <fieldset
                  v-if="donationWidgetState.steps.donation.isInView"
                  class="transition-all ease-in-out duration-300 pt-8 w-full h-full absolute top-0 z-0 flex-grow h-full pb-20 md:pb-0 transform"
                >
                  <donation-form></donation-form>
                </fieldset>
              </transition>
              
              <transition
                :enter-from-class="this.donationWidgetState.enterFromDirection"
                enter-to-class="translate-x-0"
                :leave-to-class="this.donationWidgetState.leaveToDirection"
              >
                <fieldset
                  v-if="donationWidgetState.steps.payment.isInView"
                  class="transition-all ease-in-out duration-300 pt-8 w-full h-full absolute top-0 z-0 flex-grow h-full pb-20 md:pb-0 transform"
                >
                  <payment-form></payment-form>
                </fieldset>
              </transition>
              
              <transition
                :enter-from-class="this.donationWidgetState.enterFromDirection"
                enter-to-class="translate-x-0"
                :leave-to-class="this.donationWidgetState.leaveToDirection"
              >
                <fieldset
                  v-if="donationWidgetState.steps.contact.isInView"
                  class="transition-all ease-in-out duration-300 pt-8 w-full h-full absolute top-0 z-0 flex-grow h-full pb-20 md:pb-0 transform"
                >
                  <contact-form></contact-form>
                </fieldset>
              </transition>
              
              <transition
                :enter-from-class="this.donationWidgetState.enterFromDirection"
                enter-to-class="translate-x-0"
                :leave-to-class="this.donationWidgetState.leaveToDirection"
              >
                <fieldset
                  v-if="donationWidgetState.steps.thankYou.isInView"
                  class="transition-all ease-in-out duration-300 pt-8 w-full h-full absolute top-0 z-0 flex-grow h-full pb-20 md:pb-0 transform"
                >
                  <thank-you></thank-you>
                </fieldset>
              </transition>
            
          </div>
        </div>
      </div>
    </div>
  </transition>

</template>

<script>
  import donationForm from './DonationForm'
  import contactForm from './ContactForm'
  import paymentForm from './PaymentForm'
  import thankYou from './ThankYou'
  import { watch } from 'vue'

  export default {
    name: 'make-donation-widget',
    props: {
      campaignId: {
        type: String,
        required: false,
      },

      campaign: {
        required: false,
      },

      pledgeId: {
        required: false,
        default: '',
      },

      pledge: {
        required: false,
        default: '',
      },

      showCloseIcon: {
        type: Boolean,
        required: false,
        default: true,
      },
      shouldOpenModal: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    components: { donationForm, contactForm, paymentForm, thankYou },

    data() {
      return {
        donationWidgetState: {},
        isOpen: this.shouldOpenModal,
        timeoutId: null,
      }
    },

    computed: {
      shouldShowCloseIcon() {
        return this.showCloseIcon
      },
      progressClassObject() {
        return Object.assign({},
          { 'w-1/4': this.donationWidgetState.steps.donation.isInView == true },
          { 'w-2/4': this.donationWidgetState.steps.payment.isInView == true },
          { 'w-3/4': this.donationWidgetState.steps.contact.isInView == true },
          { 'w-full': this.donationWidgetState.steps.thankYou.isInView == true }
        )
      },
    },

    created() {
      watch(
        () => this.donationWidgetState,
        () => {
          this.resetTimeout();
        },
        { deep: true }
      );
      this.donationWidgetState = this.$store.getters.donationWidget
      if (!this.donationWidgetState.campaignId) {
        this.$store.dispatch('addCampaignId', this.campaignId)
        this.donationWidgetState = this.$store.getters.donationWidget
      }
      this.$store.dispatch('updateCampaign', this.campaign)

        if (this.pledgeId) {
            this.$store.dispatch('addPledgeId', this.pledgeId)
        }
      if (this.pledge) {
        this.$store.dispatch('updatePledge', this.pledge)
      }

      // this.$parent.$on('open-donation-modal',  () => {
      this.emitter.on('open-donation-modal',  () => {
        this.isOpen = true
        document.body.classList.add('overflow-y-hidden')
        document.getElementById('app').classList.add('overflow-y-scroll')
        document.getElementById('app').classList.add('sticky')
        document.getElementById('app').classList.add('w-full')
      });
    },

    methods: {
      closeModal(e) {
        clearTimeout(this.timeoutId)
        if (e.target.classList.contains('modal-close')) {
          this.isOpen = false
          this.emitter.emit('donation-modal-close')
          document.body.classList.remove('overflow-y-hidden')
          document.getElementById('app').classList.remove('overflow-y-scroll')
          document.getElementById('app').classList.remove('sticky')
          document.getElementById('app').classList.remove('w-full')
          
          // After the modal is closed, reset the user to the first slide by default
          this.donationWidgetState.steps.donation.isInView = true
          this.donationWidgetState.steps.payment.isInView = false
          this.donationWidgetState.steps.contact.isInView = false
          this.donationWidgetState.steps.thankYou.isInView = false
        }
      },
      resetTimeout() {
        clearTimeout(this.timeoutId)
        if (this.donationWidgetState.steps.thankYou.isInView) {
          this.timeoutId = setTimeout(() => {
            this.isOpen = false
            this.emitter.emit('donation-modal-close')
            document.getElementById('app').classList.remove('overflow-y-scroll')
            document.getElementById('app').classList.remove('sticky')
            document.getElementById('app').classList.remove('w-full')
      
            // After the modal is closed, reset the user to the first slide by default
            this.donationWidgetState.steps.donation.isInView = true
            this.donationWidgetState.steps.payment.isInView = false
            this.donationWidgetState.steps.contact.isInView = false
            this.donationWidgetState.steps.thankYou.isInView = false
          }, 10000) // 10 seconds
        }
      },
    },
  }
</script>
